export default __webpack_public_path__ + "static/media/spinner-gray.f19652c2.svg";